import { render, staticRenderFns } from "./createCorpPartnerList.vue?vue&type=template&id=b45123e4&"
import script from "./createCorpPartnerList.vue?vue&type=script&lang=js&"
export * from "./createCorpPartnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports